import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Logo = styled.img`
  bottom: -33px;
  height: 70px;
  object-fit: contain;
  position: absolute;
`;
Logo.displayName = 'Logo';

export const Time = styled.div`
  align-items: center;
  background: #000000;
  border: 12px solid #3f51b5;
  border-radius: 30px;
  display: flex;
  color: #9bcdf7;
  font-family: 'Digital', system-ui;
  font-size: 100px;
  height: 162px;
  justify-content: center;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: inherit;
  width: 423px;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  color: #fff;
  font-size: 36px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  letter-spacing: 0px;
  margin-bottom: 16px;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
